
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/feed/[...slug]",
      function () {
        return require("private-next-pages/feed/[...slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/feed/[...slug]"])
      });
    }
  